import { Fragment } from 'react';
import { sanitizeHtml } from 'helpers/utils';
import { ourImpactCards } from './constants';

export const OurImpactCards = () => {
  return (
    <div className="our-impact-cards-container">
      <span className="h2-dtm">Our Impact</span>
      <div className="our-impact-cards">
        {ourImpactCards.map(card => (
          <div key={card.label} className="our-impact-card">
            <img className="our-impact-card__image" src={card.image} alt={card.label} />
            <div className="our-impact-card__texts">
              <span className="body-small-text semi-bold">{card.label}</span>
              <span
                className="h4-text color-oathBlue"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(card.headline) }}
              />
              <p className="body-text">{card.body}</p>
              <div className="our-impact-card__stats">
                {card.stats.map((stat, index) => (
                  <Fragment key={stat.label}>
                    {index > 0 && (
                      <div
                        key={`divider-${stat.label}`}
                        className="our-impact-card__stat-divider"
                      />
                    )}
                    <div key={stat.label} className="our-impact-card__stat">
                      <span className="h4-text semi-bold color-oathBlue">{stat.value}</span>
                      <span className="body-small-text">{stat.label}</span>
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
